var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"data-scroll-container":""}},[_c('TheHeader'),_c(_vm.MVComponent,{tag:"component"}),_c('HomeProduct'),_c('InterviewList'),_c('Credit'),_c('Product'),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }